module.exports = __webpack_public_path__ + "static/media/datapoints.913cb383.svg";